// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__yK2H_","notes":"Notes_notes__1mSuW"};